module.exports = __webpack_public_path__ + "img/edit.8e8b8968.svg";